import React from 'react'
import { Navigate, useLocation } from "react-router-dom"
import { AuthenticationContext } from '../App';
import { useContext } from 'react';
import { HasPermission } from './Constants';

const ProtectedRoute = ({ children }) => {
    let location = useLocation();
    const token = localStorage.getItem('agentModuleToken');
    const { authData } = useContext(AuthenticationContext);
    const Permissions = authData?.permissions?.map((it) => it.submodules).flat();
    if (token && HasPermission(location.pathname, Permissions, false)) {
        return children
    } else {
        if (token) {
            return <Navigate to='/no-permission' />
        } else {
            return <Navigate to='/login' />
        }
    }

};

export default ProtectedRoute;